import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { Key } from "@phosphor-icons/react";

export function PasswordDialog() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (f.new_password.length < 6) return toast.error("Nouveau mot de passe : 6 caractères minimum");
    setSaving(true);
    try {
      await api.post("/auth/change-password", f);
      toast.success("Mot de passe mis à jour");
      setOpen(false);
      setF({ current_password: "", new_password: "" });
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="open-password-dialog" className="w-full justify-start text-muted-foreground hover:text-foreground mb-1">
          <Key size={16} className="mr-2" /> Mot de passe
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">Changer le mot de passe</DialogTitle>
          <DialogDescription>Mettez à jour votre mot de passe de connexion.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-1.5">
            <Label>Mot de passe actuel</Label>
            <Input type="password" data-testid="current-password-input" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label>Nouveau mot de passe</Label>
            <Input type="password" data-testid="new-password-input" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={saving} data-testid="save-password-button">{saving ? "…" : "Enregistrer"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
